import uiux from "../img/services/uiuxdesign.svg";
import productdesign from "../img/services/productdesign.svg";
import development from "../img/services/development.svg";
import web from "../img/services/webdesign.svg";
import mobile from "../img/services/appdesign.svg";
import designsystem from "../img/services/designsystem.svg";
import Evolution from "../img/services/Evolution.png";
import Revolution from "../img/services/Revolution.png";
import Startup from "../img/services/Startup.png";

export const service = [
  {
    id: "1",
    title: "UI / UX & Design",
    image: uiux,
    description:
      "When it comes to building great products,  design is the most important “feature.” We’ve moved into the stage where product design dominates — it’s what sets companies apart and gives a real edge over competitors.",
  },
  {
    id: "2",
    title: "Design Sprint",
    image: productdesign,
    description:
      "The Design Sprint is an exercise for identifying critical business problems and solving them by putting realistic solutions in front of your customers, in just 5 days!",
  },
  {
    id: "3",
    title: "Mobaile Development",
    image: development,
    description:
      "We create high-quality, well-tested, maintainable, and future-ready apps that your engineers will love, and users deserve.",
  },
  {
    id: "4",
    title: "Progressive Web Application",
    image: web,
    description:
      "We help give your users a near-native experience as an alternative to native mobile apps, at less than half the cost of building native apps for all major mobile platforms.",
  },
  {
    id: "5",
    title: "Single Page Application",
    image: mobile,
    description:
      "We build apps to reach the widest possible audience base and are a pleasure to use—from high-end MacBooks connected to fast WiFi networks to low-end Android phones with slow CPUs and flaky 3G connections.",
  },
  {
    id: "6",
    title: "Design Systems",
    image: designsystem,
    description:
      "We help you build reusable UI components with CSS and HTML (or any language of your preference) and features that serve as an extension of your product that is modular and well-documented.",
  },
];

export const verticals = [
  {
    id: "1",
    title: "StartUp",
    image: Startup,
    description:
      "You’ve got a great idea? You’re thinking about starting your own company or have already founded it? But now you are wondering how you can build on your idea effectively with an experienced team? We can help you out with that.",
  },
  {
    id: "2",
    title: "Evolution",
    image: Evolution,
    description:
      "You believe in passion, open minds, obsessing over the little details and so do we. You’ve worked out your idea, but it got a bit rusty over the years. We’ll help you brush off the dust and give you a kick-start.",
  },
  {
    id: "3",
    title: "Revolution",
    image: Revolution,
    description:
      "You’re an established business, but you’re looking for something fresh and innovative. We can help you polish up, redevelop and rethink an existing idea to give it a new lease of life. We help you identify key opportunities and explore new platforms, technologies and possibilities.",
  },
];
